import { useLanguage } from './useLanguage'

export function useApiCodes() {
  const { t } = useLanguage()

  const translate = (code) => {
    if (!code) return t('apiCodes.SYSTEM_ERROR')
    return t(`apiCodes.${code}`) || code
  }

  const isSuccess = (response) => {
    return response?.data?.success === true || response?.data?.valid === true
  }

  const getCode = (response) => {
    return response?.data?.code || response?.data?.valid ? 'AUTH_TOKEN_VALID' : null
  }

  const getErrorCode = (error) => {
    return error?.response?.data?.code || error?.code || 'SYSTEM_ERROR'
  }

  const getSuccessMessage = (code) => {
    return translate(code)
  }

  const getErrorMessage = (code) => {
    return translate(code)
  }

  return {
    translate,
    isSuccess,
    getCode,
    getErrorCode,
    getSuccessMessage,
    getErrorMessage
  }
}
